import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Icon } from '@iconify/react';
import styled from 'styled-components';
import { c } from '../../theme/colorUtils';
import { Typography, Stack, Box } from '@mui/material';

function TitleBox(props) {
  const {
    title,
    onBack,
    rightButton,
    subtitle,
    showBackButton = true,
    fixed = true,
    showShadow = true,
    ...otherProps
  } = props;
  
  const history = useHistory();

  const handleBack = () => {
    // 기본 뒤로가기 동작
    history.goBack();
  };

  const renderSubtitle = () => {
    if (subtitle == null || subtitle === false) {
      return null;
    }
    if (typeof subtitle === 'string' || typeof subtitle === 'number') {
      return (
        <Typography variant="body2">
          <pre>{subtitle}</pre>
        </Typography>
      );
    }
    return <Box sx={{ width: '100%' }}>{subtitle}</Box>;
  };

  return (
    <HeaderContainer 
      {...otherProps}
    >
      {showBackButton && (
        <Icon
          icon='material-symbols:arrow-back-ios-rounded'
          onClick={onBack || handleBack}
          fontSize={24}
        />
      )}
      
      <TitleArea>
        <Typography variant="h6" gutterBottom sx={{ fontWeight: "bolder" }}>{title}</Typography>
        {renderSubtitle()}
      </TitleArea>
      
{/*       <RightButton>
        {rightButton}
      </RightButton> */}
    </HeaderContainer>
  );
}

// Styled Components
const HeaderContainer = styled(Stack)(({fixed, showShadow}) => ({
/*     ${props => props.fixed ? `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 150;
      ` : `
        position: relative;
      `}
      
      ${props => props.showShadow ? `
        box-shadow: 0 4px 5px rgba(0, 0, 0, 0.1);
      ` : ''}
       */
    background: '#FBFCFE',
    borderBottom: '1px solid #F0F1F5',
    padding:'24px 16px',
    gap:24,
  }))


const TitleArea = styled.div`
  width: 100%;
  box-sizing: border-box;
  white-space: pre-wrap;
`;

const RightButton = styled.div`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  
  & > button {
    height: 100%;
  }
`;

TitleBox.propTypes = {
  title: PropTypes.node,
  onBack: PropTypes.func,
  rightButton: PropTypes.node,
  subtitle: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.number]),
  showBackButton: PropTypes.bool,
  fixed: PropTypes.bool,
  showShadow: PropTypes.bool,
};

export default TitleBox;